import React, { memo, useEffect, useMemo, useState } from 'react';
import { Button, CodeScannerInput, Link, Select, Text, Tooltip } from 'v3/components';
import { Col } from 'react-bootstrap';
import moment from 'moment';
import { StyledCheckbox } from 'components/CheckBox/styles';
import TextArea from 'v3/components/TextArea';
import Upload from 'v3/components/Upload';
import { useModal, usePermission } from 'hooks';
import api, { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';
import PDFView from 'v3/components/PDFView';
import Lightbox from 'components/Lightbox';
import { formatDateTime } from 'v3/utils/formatter';
import { FaCheck, FaDownload, FaSearch, FaTimes } from 'react-icons/fa';
import { ChecklistProvider, useChecklist } from 'contexts/ChecklistDetails';
import theme from 'v3/theme';
import * as Styled from './styles';
import * as Function from './functions';
import SignatureModal from './SignatureModal';
import { useParams } from 'react-router-dom'
import {
  CODE_READER_QUESTION_SLUG,
  IMPLEMENT_PLATE_QUESTION_SLUG,
  VEHICLE_PLATE_QUESTION_SLUG,
} from 'v3/pages/Checklist/Questions/shared/utils';

function CheckListBodyInformations({ mode }) {
  const { checklist } = useChecklist();
  const isReport = mode === 'report';
  const levels = checklist?.serviceLevels || [];
  const travelId = checklist?.travel?.id || checklist?.travel_id || null;
  const travelCode =
    checklist?.travel?.travelNumber ||
    checklist?.travel?.code ||
    checklist?.travel_code ||
    checklist?.mainTravelCode ||
    null;

  const travelChecklistType = {
    vehicle: 'Veículo',
    colect: 'Carga coleta',
    delivery: 'Entrega da carga',
    transhipment: 'Transbordo',
    noSelected: 'Não definido',
  };

  const { id: travelIdParam } = useParams()
  const currentTravelId = Number(travelIdParam)
  const assoc = checklist?.travelChecklistAssociated?.find(
    a => a.travelAssociatedId === currentTravelId
  )
  const associacaoCreatedAt = assoc?.createdAt

  const pickLevel = slug => {
    const lvl = levels.find(l => l.serviceLevel.slug === slug) || {}
    return {
      days:     lvl.days ?? 0,
      quantity: lvl.quantity ?? 0,
      condition: lvl.condition ?? 'AND',
    }
  };

  const renderValidityText = ({ days, quantity, condition }) => {
    if (days > 0 && quantity > 0) {
      const conj = condition === 'AND' ? 'e' : 'ou'
      return `Válido por ${days} dias ${conj} ${quantity} viagens`
    }
    if (days > 0) {
      return `Válido por ${days} dias`
    }
    if (quantity > 0) {
      return `Válido por ${quantity} viagens`
    }
    return null
  };

  const fleet    = pickLevel('PROPRIOS')
  const ouro     = pickLevel('OURO')
  const bronze   = pickLevel('BRONZE')
  const terceiro = pickLevel('TERCEIRO')
  const fleetText    = renderValidityText(fleet)
  const ouroText     = renderValidityText(ouro)
  const bronzeText   = renderValidityText(bronze)
  const terceiroText = renderValidityText(terceiro)

  return (
    <Styled.StyledRow>
      <Col xs={12} md={6}>
        <Styled.StyledText bold>Título do Checklist:</Styled.StyledText>
        <Styled.StyledText>{checklist?.name}</Styled.StyledText>
      </Col>
      <Col xs={12} md={6}>
        <Styled.StyledText bold>Criado por:</Styled.StyledText>
        <Styled.StyledText>
          {checklist?.userCreated?.username && checklist?.createdAt
            ? `${checklist?.userCreated?.username} ${moment(
              checklist?.createdAt
            ).format('DD/MM/YYYY HH:mm:ss')}`
            : 'Não identificado'}
        </Styled.StyledText>
      </Col>
      <Col xs={12} md={6}>
        <Styled.StyledText bold>Tipo de Checklist:</Styled.StyledText>
        <Styled.StyledText>
          {travelChecklistType[checklist?.checklistType?.slug || 'noSelected']}
        </Styled.StyledText>
      </Col>
      <Col xs={12} md={6}>
        <Styled.StyledText bold>Respondido por:</Styled.StyledText>
        <Styled.StyledText>
          {checklist?.userUpdated?.username && checklist?.answeredAt
            ? `${checklist?.userUpdated?.username} ${moment(
              checklist?.answeredAt
            ).format('DD/MM/YYYY HH:mm:ss')}`
            : 'Não respondido'}
        </Styled.StyledText>
      </Col>
      {checklist?.answeredAt && (
        <>
          <Col xs={12} md={6}>
            <>
              <Styled.StyledText bold>
                CNPJ:
              </Styled.StyledText>
              <Styled.StyledText>
                {checklist?.travel?.loads?.taker?.cpfCnpj || 'Não informado'}
              </Styled.StyledText>
            </>
          </Col>
          <Col xs={12} md={6}>
            {checklist?.answeredAt && (
              <>
                <Styled.StyledText bold>Nome do Motorista:</Styled.StyledText>
                <Styled.StyledText>
                  {checklist?.driverSign?.sign?.user?.username ? checklist?.driverSign?.sign?.user?.username :
                    checklist?.travel?.driver?.socialName ? checklist?.travel?.driver?.socialName :
                      'Não informado'}
                </Styled.StyledText>
              </>
            )}
          </Col>
          <Col xs={12} md={6}>
            <Styled.StyledText bold>Negociação:</Styled.StyledText>
            <Styled.StyledText>
              {checklist?.checklist?.negotiation?.name
                ? checklist.checklist.negotiation.name
                : 'Não informado'}
            </Styled.StyledText>
          </Col>
        </>
      )}
      <Col xs={12} md={6}>
        {checklist?.answeredAt && (
          <>
            <Styled.StyledText bold>Telefone Motorista:</Styled.StyledText>
            <Styled.StyledText>
              {checklist?.driverSign ? checklist?.driverSign?.sign?.user?.phonenumber :
                checklist?.travel?.driver?.phone ? checklist?.travel?.driver?.phone :
                  'Não Informado'}
            </Styled.StyledText>
          </>
        )}
      </Col>
      <Col xs={12} md={6}>
        <Styled.StyledText bold>Motorista Responde Pelo APP:</Styled.StyledText>
        <Styled.StyledText>
          {checklist?.availableForDriver ? 'Sim' : 'Não'}
        </Styled.StyledText>
      </Col>
      <Col xs={12} md={6} className="mt-3">
        <Styled.StyledText bold>Localização Assinatura Motorista:</Styled.StyledText>

        {checklist?.answeredAt && checklist?.driverSign ? (
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${checklist.driverSign.latitude},${checklist.driverSign.longitude}`}
            target="_blank"
          >
            <Styled.StyledText>
              {`${checklist.driverSign.latitude}, ${checklist.driverSign.longitude}`}
            </Styled.StyledText>
          </a>
        ) : (
          <Styled.StyledText>Não assinado</Styled.StyledText>
        )}
      </Col>

      {fleetText && (
        <Col xs={12} md={6}>
          <Styled.StyledText bold>Frota:</Styled.StyledText>
          <Styled.StyledText>{fleetText}</Styled.StyledText>
        </Col>
      )}

      {ouroText && (
        <Col xs={12} md={6}>
          <Styled.StyledText bold> Agregado Ouro:</Styled.StyledText>
          <Styled.StyledText>{ouroText}</Styled.StyledText>
        </Col>
      )}

      {bronzeText && (
        <Col xs={12} md={6}>
          <Styled.StyledText bold>Agregado Bronze:</Styled.StyledText>
          <Styled.StyledText>{bronzeText}</Styled.StyledText>
        </Col>
      )}

      {terceiroText && (
        <Col xs={12} md={6}>
          <Styled.StyledText bold>Terceiro:</Styled.StyledText>
          <Styled.StyledText>{terceiroText}</Styled.StyledText>
        </Col>
      )}

      {isReport && (
        <>
          <Col xs={12} md={6} className="mt-3">
            <Styled.StyledText bold>Veículo tração:</Styled.StyledText>
            <Styled.StyledText>
              {checklist?.vehiclePlate || 'Não informado'}
            </Styled.StyledText>
          </Col>
        </>
      )}

      {isReport && (
        <>
          <Col xs={12} md={6} className="mt-3">
            <Styled.StyledText bold>Implementos:</Styled.StyledText>
            <Styled.StyledText>
              {checklist?.implements?.length
                ? checklist.implements.join(', ')
                : 'Não informado'}
            </Styled.StyledText>
          </Col>
        </>
      )}

      <Col xs={12} md={6}>
        <Styled.StyledText bold>Viagem principal:</Styled.StyledText>
        <Styled.StyledText>
          {travelId ? (
            <a
              href={`/viagens/${travelId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: '0.9rem',
                textDecoration: 'underline',
                color: '#007bff',
                fontWeight: 500
              }}
            >
              {travelCode || travelId}
            </a>
          ) : (
            'Não informado'
          )}
        </Styled.StyledText>
      </Col>

      {isReport && (
        <Col xs={12} md={6} className="mt-3">
          <Styled.StyledText bold>Viagens associadas:</Styled.StyledText>
          <Styled.StyledText>
            {checklist?.travelChecklistAssociated?.length
              ? checklist.travelChecklistAssociated.map((associatedTravel, index) => (
                <>
                  <a
                    href={`/viagens/${associatedTravel.travelAssociatedId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      fontSize: '0.9rem',
                      textDecoration: 'underline',
                      color: '#007bff',
                      fontWeight: 500
                    }}
                  >
                    {associatedTravel.travelAssociatedId}
                  </a>
                  {index < checklist.travelChecklistAssociated.length - 1 && ', '}
                </>
              ))
              : 'Não informado'}
          </Styled.StyledText>
        </Col>
      )}

      {associacaoCreatedAt && (
        <Col xs={12} md={6} className="mt-3">
          <Styled.StyledText bold>Data associação:</Styled.StyledText>
          <Styled.StyledText>
            {associacaoCreatedAt
              ? moment(associacaoCreatedAt).format('DD/MM/YYYY HH:mm:ss')
              : 'Não informado'}
          </Styled.StyledText>
        </Col>
      )}
      <Col xs={12} md={12}>
        <Styled.StyledText bold>Descrição do Checklist:</Styled.StyledText>
        <Styled.StyledText style={{ 'word-wrap': 'break-word'}}>{checklist?.description}</Styled.StyledText>
      </Col>
    </Styled.StyledRow>
  );
}

function Question({
  question,
  index,
  openUploadAttachment,
  setOpenUploadAttachment,
  cleanAttachments,
}) {
  const { answered } = useChecklist();
  return (
    <Col xs={12}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6 }}>
        <Styled.StyledText bold style={{ minWidth: 18, lineHeight: '20px', marginTop: 3 }}>
          {index}
        </Styled.StyledText>
        <Styled.QuestionContainer>
          <Styled.StyledText>{question?.question}</Styled.StyledText>
          {question?.required && (
            <Styled.StyledText as="span">*</Styled.StyledText>
          )}
        </Styled.QuestionContainer>
        {question?.needAttachment && !answered && (
          <Button
            variant={openUploadAttachment ? 'secondary' : 'primary'}
            style={{ margin: '8px 0' }}
            onClick={() => {
              setOpenUploadAttachment(prevState => {
                if (cleanAttachments && prevState === true) {
                  cleanAttachments();
                }
                return !prevState;
              });
            }}
          >
            {openUploadAttachment ? 'Cancelar ' : 'Anexo'}
          </Button>
        )}
      </div>
    </Col>
  );
}

function DisplayAttachments({ attachments = [], attachment }) {
  const [isHovering, setHovering] = useState(false);
  const [isShowingModal, setShowingModal] = useState(false);

  const fullPath = useMemo(() => Function.fullPath(attachment), [attachment]);

  const attachmentsWithoutPDF = useMemo(
    () => Function.attachmentsWithoutPDF(attachments),
    [attachments]
  );

  const [lightbox, setLightbox] = useState({
    isOpen: false,
    attachments: attachmentsWithoutPDF,
    index: 0,
  });

  const lightboxIndexes = useMemo(
    () => Function.lightboxIndexes(lightbox),
    [lightbox.index, lightbox.attachments]
  );

  const lightboxTitle = useMemo(
    () => Function.lightboxTitle(lightbox),
    [lightbox.index, lightbox.attachments]
  );
  return (
    <div>
      <Styled.StyledModal
        show={isShowingModal}
        dialogClassName="modal-90w"
        onHide={() => setShowingModal(false)}
        heading="Visualizar PDF"
        body={<PDFView file={fullPath} />}
      />
      <div
        className="position-relative ml-2"
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        style={{
          width: 270,
          height: 160,
          background: `url(${
            attachment?.name.split('.').pop() === 'pdf'
              ? '/images/default-doc.png'
              : fullPath
            }) center center`,
          backgroundSize: '100%',
        }}
      >
        {lightbox.isOpen && (
          <Lightbox
            mainSrc={Function.getImagePath({
              index: lightbox.index,
              alwaysDisplay: true,
              lightbox,
              lightboxIndexes,
            })}
            nextSrc={Function.getImagePath({
              index: lightboxIndexes.next,
              lightbox,
              lightboxIndexes,
            })}
            prevSrc={Function.getImagePath({
              index: lightboxIndexes.previous,
              lightbox,
              lightboxIndexes,
            })}
            onCloseRequest={() =>
              setLightbox(prev => ({ ...prev, isOpen: false }))
            }
            onMovePrevRequest={() =>
              setLightbox(prev => ({
                ...prev,
                index: lightboxIndexes.previous,
              }))
            }
            onMoveNextRequest={() =>
              setLightbox(prev => ({
                ...prev,
                index: lightboxIndexes.next,
              }))
            }
            imageTitle={lightboxTitle}
            reactModalStyle={{
              overlay: {
                zIndex: 2000,
              },
            }}
          />
        )}
        {isHovering && (
          <Styled.Backdrop>
            {attachment.name.split('.').pop() !== 'xlsx' && (
              <button
                type="button"
                onClick={() =>
                  Function.handleClickOpenAttachment({
                    attachment,
                    setShowingModal,
                    setLightbox,
                    attachmentsWithoutPDF,
                  })
                }
              >
                <FaSearch color="#fff" size={32} />
              </button>
            )}
            <a href={fullPath} download>
              <FaDownload color="#fff" size={32} />
            </a>
          </Styled.Backdrop>
        )}
        <Styled.DateTime>
          <Text type="label" color="white">
            {formatDateTime(attachment?.created_at ? attachment?.created_at : attachment?.createdAt ? attachment?.createdAt : 'Não informado')}
          </Text>
        </Styled.DateTime>
      </div>
    </div>
  );
}

function RenderAttachment({ question }) {
  const { answered, setQuestions } = useChecklist();
  return answered ? (
    question?.attachments[0]?.attachment?.name.indexOf('mp4') > 0 ?
      <video width="320" height="240" controls>
        <source src={question?.attachments[0]?.attachment?.full_path}/>
      </video>
      :
      <Styled.AnswerContainer>
        {question?.attachments.length > 0 &&
          question.attachments.map(({ attachment }) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <DisplayAttachments
                attachment={attachment}
                attachments={question.attachments}
              />
              <Text
                type="regular"
                style={{
                  'max-width': '75%',
                  'word-wrap': 'break-word',
                }}
              >
                {attachment.description}
              </Text>
            </div>
          ))}
      </Styled.AnswerContainer>
  ) : (
    <Upload
      name="file"
      label="Arquivo máximo de 20MB"
      accept=".jpg,.jpeg,.png,.mkv,.mp4"
      multiple
      onChange={({ target: { files } }) => {
        setQuestions(prevState => {
          const newQuestions = [...prevState];
          const index = newQuestions.findIndex(({ id }) => id === question?.id);
          const currentQuestion = newQuestions[index];
          newQuestions[index].error = null;
          newQuestions[index].attachment = {
            files,
            questionId: currentQuestion.id,
          };
          return newQuestions;
        });
      }}
    />
  );
}

const Response = memo(function ResponseComponent({ question }) {
  const { answered, setQuestions } = useChecklist();
  const OPTIONS_TYPES = ['unique', 'multiple', 'logic'];
  const typeSlug = question?.type;
  const isVehiclePlate = typeSlug === VEHICLE_PLATE_QUESTION_SLUG;
  const isImplementPlate =
    typeSlug === IMPLEMENT_PLATE_QUESTION_SLUG || typeSlug === 'wagon_plate';
  const isCodeReader =
    typeSlug === CODE_READER_QUESTION_SLUG || typeSlug === 'code';

  const normalizePlateOptions = data => {
    if (Array.isArray(data)) {
      return data;
    }
    if (Array.isArray(data?.data)) {
      return data.data;
    }
    if (Array.isArray(data?.rows)) {
      return data.rows;
    }
    if (data && typeof data === 'object') {
      return [data];
    }
    return [];
  };

  const selectedPlateOption =
    question?.plateOption ||
    question?.vehicle ||
    question?.wagon ||
    (question?.descriptiveResponse
      ? {
        id: question.descriptiveResponse,
        plate: question.descriptiveResponse,
      }
      : null);

  const handleChangePlate = value => {
    setQuestions(prevState => {
      const newQuestions = [...prevState];
      const index = newQuestions.findIndex(item => item.id === question?.id);
      if (index < 0) {
        return prevState;
      }
      newQuestions[index].plateOption = value || null;
      newQuestions[index].descriptiveResponse = value?.plate || '';
      if (isVehiclePlate) {
        newQuestions[index].vehicleId = value?.id || null;
        newQuestions[index].wagonId = null;
      }
      if (isImplementPlate) {
        newQuestions[index].wagonId = value?.id || null;
        newQuestions[index].vehicleId = null;
      }
      newQuestions[index].error = null;
      return newQuestions;
    });
  };

  const handleChangeCode = value => {
    setQuestions(prevState => {
      const newQuestions = [...prevState];
      const index = newQuestions.findIndex(item => item.id === question?.id);
      if (index < 0) {
        return prevState;
      }
      newQuestions[index].descriptiveResponse = value || '';
      newQuestions[index].code = value || null;
      newQuestions[index].error = null;
      return newQuestions;
    });
  };

  const fetchVehiclePlate = async search => {
    try {
      const response = await api.get('vehicle/license_plate', {
        params: { search },
      });
      return normalizePlateOptions(response?.data);
    } catch (error) {
      return [];
    }
  };

  const fetchImplementPlate = async search => {
    try {
      const response = await api.get('plate/wagons', {
        params: { search },
      });
      return normalizePlateOptions(response?.data);
    } catch (error) {
      return [];
    }
  };

  if (question?.type === 'image' || question?.type === 'video') {
    return <RenderAttachment question={question} />;
  }

  if (OPTIONS_TYPES.includes(question?.type)) {
    return (
      <Styled.AnswerContainer>
        {question?.responses?.length > 0 &&
          question.responses.map((response, responseIndex) => (
            <div key={response.id}>
              <StyledCheckbox
                onChange={(_a, isChecked) =>
                  Function.handleOptions({
                    isChecked,
                    responseIndex,
                    setQuestions,
                    question,
                  })
                }
                checked={response.selected === true}
                disabled={answered}
              />
              <Styled.StyledText as="span">
                {response.description}
              </Styled.StyledText>
            </div>
          ))}
        {answered && question?.attachments?.length > 0 && (
          <>
            <Styled.StyledText bold>
              Imagens anexadas a pergunta:
            </Styled.StyledText>
            <RenderAttachment question={question} />
          </>
        )}
      </Styled.AnswerContainer>
    );
  }

  if (isVehiclePlate || isImplementPlate) {
    return (
      <Styled.AnswerContainer>
        <Select.Async
          label={isVehiclePlate ? 'Placa do veículo de tração *' : 'Placa do implemento / carroceria *'}
          onSearch={isVehiclePlate ? fetchVehiclePlate : fetchImplementPlate}
          value={selectedPlateOption}
          onChange={handleChangePlate}
          removeInputMin
          getOptionLabel={option => {
            let label = option?.plate || '';
            if (option?.vehicle?.plate) {
              label += ` - Tração ${option.vehicle.plate}`;
            }
            return label;
          }}
          getOptionValue={option => option?.id}
          isDisabled={answered}
        />
      </Styled.AnswerContainer>
    );
  }

  if (isCodeReader) {
    return (
      <Styled.AnswerContainer>
        <CodeScannerInput
          label="Código *"
          value={question?.descriptiveResponse || ''}
          onChange={handleChangeCode}
          disabled={answered}
        />
      </Styled.AnswerContainer>
    );
  }

  return (
    <Styled.AnswerContainer>
      <TextArea
        value={question?.descriptiveResponse}
        maxLength={250}
        onChange={e => Function.handleTextArea(e, setQuestions, question)}
        disabled={answered}
      />
      {answered && question?.attachments?.length > 0 && (
        <>
          <Styled.StyledText bold>
            Imagens anexadas a pergunta:
          </Styled.StyledText>
          <RenderAttachment question={question} />
        </>
      )}
    </Styled.AnswerContainer>
  );
});

const cleanSubQuestions = (setQuestions, subQuestion) => {
  setQuestions(prevState => {
    const newState = [...prevState];
    const indexSubQuestion = newState.findIndex(
      item => item.id === subQuestion.id
    );
    newState[indexSubQuestion].responses.forEach((_response, i) => {
      newState[indexSubQuestion].responses[i].selected = false;
    });
    newState[indexSubQuestion].descriptiveResponse = null;
    newState[indexSubQuestion].attachments = [];
    return prevState;
  });
};

const QuestionsList = memo(function QuestionsListComponent({
  question,
  index,
}) {
  const { questions, setQuestions } = useChecklist();
  const [openUploadAttachment, setOpenUploadAttachment] = useState(false);
  const cleanAttachments = () => {
    setQuestions(prevState => {
      const newQuestions = [...prevState];
      newQuestions[index].attachment = {};
      return newQuestions;
    });
  };

  if (question?.isSubQuestion) return null;
  let subQuestions;

  if (question?.hasSubQuestion) {
    subQuestions = questions.filter(
      ({ fatherQuestionId }) => fatherQuestionId === question?.id
    );
  }

  if (question?.mediaError && !openUploadAttachment) {
    setOpenUploadAttachment(true);
  }

  return (
    <Col md={12} lg={6} key={question?.id}>
      <Question
        index={`${question.order}`}
        question={question}
        openUploadAttachment={openUploadAttachment}
        setOpenUploadAttachment={setOpenUploadAttachment}
        cleanAttachments={cleanAttachments}
      />
      <Response question={question} />
      {question?.error && (
        <Styled.StyledText color="#F64E60">{question?.error}</Styled.StyledText>
      )}
      {openUploadAttachment && (
        <div style={{ padding: '0 7.5px', marginTop: 8 }}>
          <Upload
            label="Arquivo máximo de 1MB"
            accept=".jpg,.jpeg,.png"
            multiple
            onChange={({ target: { files } }) => {
              setQuestions(prevState => {
                const newQuestions = [...prevState];
                const currentQuestion = newQuestions[index];
                currentQuestion.attachment = {
                  files,
                  questionId: currentQuestion.id,
                };
                currentQuestion.mediaError = null;
                currentQuestion.error = null;
                return newQuestions;
              });
              return null;
            }}
          />
          {question?.mediaError && (
            <Styled.StyledText color="#F64E60">
              {question?.mediaError}
            </Styled.StyledText>
          )}
        </div>
      )}
      {question?.hasSubQuestion &&
        subQuestions?.length &&
        subQuestions.map((subQuestion, indexSubquestion) => {
          const isSelectedTrigger = question.responses.find(response => {
            return question.questionTrigger.find(
              trigger => response.id === trigger.id && response.selected
            );
          });

          if (!isSelectedTrigger) {
            cleanSubQuestions(setQuestions, subQuestion);
          }

          if (isSelectedTrigger) {
            return (
              <div style={{ marginLeft: 15 }}>
                <Question
                  index={`${question.order}.${indexSubquestion + 1}`}
                  question={subQuestion}
                />
                <Response question={subQuestion} />
                {subQuestion?.error && (
                  <Styled.StyledText color="#F64E60">
                    {subQuestion?.error}
                  </Styled.StyledText>
                )}
              </div>
            );
          }
          return null;
        })}
    </Col>
  );
});

function CheckListQuestions() {
  const { questions } = useChecklist();

  return (
    <Styled.StyledRow style={{ marginTop: 16 }}>
      {questions.map((question, index) => (
        <QuestionsList key={question?.id} question={question} index={index} />
      ))}
    </Styled.StyledRow>
  );
}

function Header({ downloadChecklist, hideExport, mode }) {
  const { isFetching, checklist } = useChecklist();
  const { id: travelIdParam } = useParams();
  const currentTravelId = Number(travelIdParam);

  const assocs = checklist?.travelChecklistAssociated
    ?.filter(a => a.travelAssociatedId === currentTravelId) || [];

  const assoc = assocs
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0] || null;

  const renderStatusTag = () => {
    if (checklist?.status?.slug === 'ANSWERED' && assoc) {
      return (
        <Link
          to={`/viagens/${assoc.travelMainId}`}
          style={{
            backgroundColor: '#FFF3CD',
            color: '#fff67cff',
            padding: '4px 8px',
            borderRadius: 10,
            fontSize: 12,
            marginLeft: 8,
            display: 'inline-block',
            textDecoration: 'none',
          }}
        >
          Associado
        </Link>
      );
    }

    if (checklist?.status?.slug === 'EXPIRED') {
      return (
        <span
          style={{
            backgroundColor: '#f8d7da',
            color: '#ff5869ff',
            padding: '4px 8px',
            borderRadius: 10,
            fontSize: 12,
            marginLeft: 8,
            display: 'inline-block',
          }}
        >
          Expirado
        </span>
      );
    }

    if (checklist?.status?.slug === 'CANCELED') {
      return (
        <span
          style={{
            backgroundColor: '#f5c6cb',
            color: '#ff3c4fff',
            padding: '4px 8px',
            borderRadius: 10,
            fontSize: 12,
            marginLeft: 8,
            display: 'inline-block',
          }}
        >
          Anulado
        </span>
      );
    }

    return null;
  };

  return (
    <Styled.SpaceBetween>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <Text color="dark" type="header">Detalhes do Checklist </Text>
        <Text color="dark" type="header">
          {checklist?.checklist?.default ? ' - Padrão - ' : ' - '}
        </Text>
        <Text color="dark" type="header">{checklist?.id}</Text>
        {renderStatusTag()}
      </div>
      {checklist?.status?.slug === 'ANSWERED' && hideExport == null && (
        <Button loading={isFetching} onClick={downloadChecklist}>
          Exportar
        </Button>
      )}
    </Styled.SpaceBetween>
  );
}

function Body({ mode }) {
  return (
    <div>
      <CheckListBodyInformations mode={mode} />
      <CheckListQuestions />
    </div>
  );
}

function Footer({ warningModal, handleSaveChecklist, toSign, hideToSingButton }) {
  const { isFetching, answered, checklist } = useChecklist();
  const hasPermissionToAnull = usePermission('ANULAR_CHECKLIST_VIAGEM');
  return (
    <div style={{ display: 'flex', gap: 10 }}>
      {checklist?.status?.slug !== 'ANSWERED' &&
        (hasPermissionToAnull ? (
          <Button
            loading={isFetching}
            onClick={warningModal.open}
            variant="error"
          >
            Anular checklist
          </Button>
        ) : (
          <Tooltip
            content={
              <Text>
                Você não tem permissão para anular um checklist de viagem!
              </Text>
            }
          >
            <Button
              disabled={!hasPermissionToAnull}
              loading={isFetching}
              variant="error"
            >
              Anular checklist
            </Button>
          </Tooltip>
        ))}
      {!answered && (
        <Button loading={isFetching} onClick={handleSaveChecklist}>
          Enviar
        </Button>
      )}

      {answered &&
        (checklist?.driverSign ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text color={theme.colors.success}>
              Assinado pelo Motorista <FaCheck />
            </Text>
            <Text>{checklist?.driverSign?.sign?.user?.username}</Text>
            <Text>
              {moment(checklist?.driverSign?.created_at).format('DD/MM/YYYY HH:mm')}
            </Text>
          </div>
        ) : (
          <Text color={theme.colors.danger}>
            Não assinado pelo Motorista <FaTimes />
          </Text>
        ))}

      {answered &&
        (checklist?.inspectorSign ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text color={theme.colors.success}>
              Assinado pelo Vistoriador <FaCheck />
            </Text>
            <Text>{checklist?.inspectorSign?.sign?.user?.username}</Text>
            <Text>
              {moment(checklist?.inspectorSign?.created_at).format('DD/MM/YYYY HH:mm')}
            </Text>
          </div>
        ) : (
          hideToSingButton == null ? (
            <Button loading={isFetching} onClick={toSign}>
              Assinar
            </Button>
          ) : (
            <>
              <Text color={theme.colors.danger}>
                Não assinado pelo Vistoriador <FaTimes />
              </Text>
            </>
          )
        ))}
    </div>
  );
}

export default function CheckListDetailModal({
  modalHook,
  checklist,
  travelData,
  fetchTravelChecklists,
  setSelectedChecklistId,
  onConfirmResponse = async () => { },
  hideFooter,
  hideExport,
  hideToSingButton,
  handleClose = () => { },
  fetchFeed,
  mode,
  fetchTravel
}) {
  const anullModal = useModal();
  const confirmResponseModal = useModal();
  const confirmaSignatureModal = useModal();
  const signatureModal = useModal();
  const snackbar = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [signature, setSignature] = useState(null);
  const [location, setLocation] = useState(null);

  const handleCancelChecklist = async () => {
    if (!checklist?.id) return;
    try {
      setIsFetching(true);
      await cooperplaceApi.delete(`/travel-checklist/${checklist.id}`, {
        params: {
          travelId: travelData?.id,
        },
      });
      await fetchTravelChecklists();
      await onConfirmResponse();
      if(fetchFeed){
        fetchFeed();
      }
      anullModal.close();
      modalHook.close();
    } catch (error) {
      snackbar.show(<Text>Erro ao anular checklist</Text>, {
        type: 'error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const handleSaveChecklist = async () => {
    const isValidChecklist = Function.validateChecklist(
      questions,
      setQuestions
    );
    if (!isValidChecklist) return;
    confirmResponseModal.open();
  };

  const downloadChecklist = async () => {
    try {
      setIsFetching(true);
      await cooperplaceApi
        .get(`travel-checklist/${checklist?.id}/export`, {
          params: {
            travelId: travelData?.id,
          },
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/pdf',
          },
        })
        .then(response => {
          const fileName = `checklist_${checklist.checklistType.slug}_${checklist.id}.pdf`;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        });
    } catch (error) {
      snackbar.show(<Text>Erro ao exportar checklist</Text>, {
        type: 'error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const handleConfirmResponse = async () => {
    try {
      setIsFetching(true);
      const questionsWithMedia = questions.filter(
        question => !!question.attachment?.files
      );

      if (questionsWithMedia.length) {
        await Function.sendMedias(questionsWithMedia);
      }

      const confirmedMediasQuestions = [...questions];
      questionsWithMedia.forEach(question => {
        const index = confirmedMediasQuestions.findIndex(
          confirmedQuestion => confirmedQuestion.id === question.id
        );
        confirmedMediasQuestions[index].sentAttachment = true;
      });
      await Function.answerChecklist(confirmedMediasQuestions, checklist?.id);
      await fetchTravelChecklists();
      await onConfirmResponse();
      if(fetchFeed){
        fetchFeed();
      }
      modalHook.close();
    } catch (error) {
      snackbar.show(<Text>Erro ao responder checklist</Text>, {
        type: 'error',
      });
    } finally {
      setIsFetching(false);
      confirmResponseModal.close();
    }
  };

  const getUserSignature = async () => {
    try {
      setIsFetching(true);
      const {
        data: { base64 },
      } = await cooperplaceApi.get('users/signature');
      setSignature(base64);
      return base64;
    } catch (error) {
      snackbar.show(<Text>Erro ao trazer assinatura</Text>, {
        type: 'error',
      });
    } finally {
      setIsFetching(false);
    }
    return null;
  };

  const signChecklist = async () => {
    try {
      setIsFetching(true);
      const userIp = await fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          const { ip } = data;
          return ip;
        })
        .catch(error => {
          console.error('Erro ao obter o IP:', error);
        });

      const response = await cooperplaceApi.post(
        `travel-checklist-response/${checklist.id}/signature`,
        {
          latitude: location?.latitude,
          longitude: location?.longitude,
          ip: userIp,
        }
      );

      snackbar.show(
        <Text>
          {response?.data?.message || 'Checklist assinado com sucesso!'}
        </Text>,
        {
          type: 'success',
        }
      );

      setSelectedChecklistId(checklist.id);

      fetchTravelChecklists();

      if (fetchTravel) {
        fetchTravel();
      }

      if (fetchFeed) {
        fetchFeed();
      }

    } catch (error) {
      snackbar.show(<Text>Erro ao assinar checklist</Text>, {
        type: 'error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const toSign = () => confirmaSignatureModal.open();

  const confirmSign = async () => {
    confirmaSignatureModal.close();
    const base64 = await getUserSignature();
    if (base64) {
      await signChecklist();
    } else {
      signatureModal.open();
    }
  };

  const getLocation = () => {
    if (navigator?.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
        },
        error => {
          console.error('Erro ao obter localização:', error.message);
        }
      );
    } else {
      console.error('Geolocalização não suportada');
    }
  };

  useEffect(() => {
    if (checklist?.questions?.length) {
      const formatedResponses = checklist.questions
        .sort((a, b) => a.order - b.order)
        .map(Function.normalizeQuestions);
      setQuestions(formatedResponses);
    }
  }, [checklist]);

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <ChecklistProvider
      value={{
        checklist,
        questions,
        setQuestions,
        answered: !!checklist?.userUpdated,
        isFetching,
      }}
    >
      <Styled.StyledModal
        centered
        show={modalHook.isOpen}
        body={<Body mode={mode}/>}
        footer={
          hideFooter ? null : (
            <Footer
              warningModal={anullModal}
              handleSaveChecklist={handleSaveChecklist}
              toSign={toSign}
              hideToSingButton={hideToSingButton}
            />
          )
        }
        $width="1000px"
        heading={
          <Header
            downloadChecklist={downloadChecklist}
            hideExport={hideExport}
            mode={mode}
          />
        }
        handleClose={() => {
          handleClose();
          modalHook.close();
        }}
      />
      <Styled.StyledModal
        centered
        show={anullModal.isOpen}
        heading={<Styled.StyledText>Anular checklist</Styled.StyledText>}
        handleClose={anullModal.close}
        $width="1000px"
        body={
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Styled.StyledText>
              Essa ação é{' '}
              <Styled.StyledText color="#F64E60" as="span">
                irreversível
              </Styled.StyledText>
              , tem certeza que deseja prosseguir?
            </Styled.StyledText>
          </div>
        }
        footer={
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              loading={isFetching}
              onClick={anullModal.close}
              variant="secondary"
            >
              Cancelar
            </Button>
            <Button loading={isFetching} onClick={handleCancelChecklist}>
              Anular
            </Button>
          </div>
        }
        backdropClassName="backdrop-occurrences-aditional-field"
      />
      <Styled.StyledModal
        centered
        show={confirmResponseModal.isOpen}
        heading={<Styled.StyledText>Responder checklist</Styled.StyledText>}
        handleClose={confirmResponseModal.close}
        $width="1000px"
        body={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Styled.StyledText>
              Confirma as respostas inseridas no checklist?
            </Styled.StyledText>
            <Styled.StyledText>
              Após respostas salvas não é possível alterar
            </Styled.StyledText>
          </div>
        }
        footer={
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              loading={isFetching}
              onClick={confirmResponseModal.close}
              variant="secondary"
            >
              Cancelar
            </Button>
            <Button loading={isFetching} onClick={handleConfirmResponse}>
              Confirmar
            </Button>
          </div>
        }
        backdropClassName="backdrop-occurrences-aditional-field"
      />
      <SignatureModal
        signChecklist={signChecklist}
        signature={signature}
        signatureModal={signatureModal}
        snackbar={snackbar}
        setIsFetching={setIsFetching}
        isFetching={isFetching}
        $width="1000px"
      />
      <Styled.StyledModal
        centered
        show={confirmaSignatureModal.isOpen}
        heading={<Styled.StyledText>Assinar checklist</Styled.StyledText>}
        handleClose={confirmaSignatureModal.close}
        $width="1000px"
        body={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Styled.StyledText>
              Tem certeza de que deseja assinar o checklist?
            </Styled.StyledText>
            <Styled.StyledText>
              Você será o responsável pelas informações contidas.
            </Styled.StyledText>
          </div>
        }
        footer={
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              loading={isFetching}
              onClick={confirmaSignatureModal.close}
              variant="secondary"
            >
              Cancelar
            </Button>
            <Button loading={isFetching} onClick={confirmSign}>
              Confirmar
            </Button>
          </div>
        }
        backdropClassName="backdrop-occurrences-aditional-field"
      />
    </ChecklistProvider>
  );
}
